import { messaging } from "../firebase2";
import { deleteToken, getToken, onMessage } from "firebase/messaging";

// Your existing function (minor fix)
export const requestPermissionAndGetToken = async () => {
  try {
    // console.log("🔔 Requesting permission...");

    const permission = await Notification.requestPermission();

    // console.log("Permission:", permission);

    if (permission !== "granted") {
      // console.log("❌ Permission denied");
      return null;
    }

    const token = await getToken(messaging, {
        vapidKey: "BB7ms3Uyc3ds5TZILEmqlbFIHJUMwCTy2aYVa7IHo-UNdhFPBEsf59WQOBUDPSlO3n2FlOEobWiKqHUOJSp26pU"  
    });

    if (token) {
      // console.log("✅ TOKEN:", token);
      return token;
    } else {
      // console.log("❌ No token received");
      return null;
    }
  } catch {
    return null;
  }
};

// ✅ NEW: Foreground Message Listener
export const setupForegroundListener = (callback) => {
  onMessage(messaging, (payload) => {
    // console.log("🔔 Foreground FCM:", payload);
    if (callback) callback(payload);  // Your toast/UI update
    // Or auto: toast.info(`${payload.notification?.title}: ${payload.notification?.body}`);
  });
};

export const revokeNotificationToken = async () => {
  try {
    await deleteToken(messaging);
  } catch {
    // Push cleanup is best-effort and must not prevent a local logout.
  }
};
